"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQQSC = void 0;
var react_1 = __importDefault(require("react"));
var quotetable_1 = require("../quotetable");
var crumbs_1 = require("../crumbs");
var maintab_1 = require("./shared/maintab");
/**
 * 期权市场
 * @returns
 */
function PageQQSC() {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(maintab_1.CustomMainTab2, { itemlist: [{ title: "全部期权", path: "" }], mt: 10 }),
        react_1.default.createElement(quotetable_1.QuoteTable, { mt: 10, custom_hash: "options_qqsc_index" })));
}
exports.PageQQSC = PageQQSC;
